export enum CheckListStatus {
    NOT_UPLOADED,
    NOT_UPLOADED_OPTIONAL,
    NOT_VERIFIED,
    VERIFYING,
    VERIFIED,
    UPLOADED,
    FAILED
}

export enum ValidationType {
    NONE,
    PDF_CHECKLIST
}

export interface CheckList {
    id: string;
    name: string;
    description: string;
    templateName: string;
    template?: any;
    checkListStatus: CheckListStatus;
    required: false;
    assets: any[];
    validationType: ValidationType;
}
